import { TrackingEventsActionTypes } from './constants';

type TrackingEventsAction = { type: string, payload: {} | string };

export const trackingEventsApiResponseSuccess = (actionType: string, data: any): TrackingEventsAction => ({
    type: TrackingEventsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const trackingEventsApiResponseError = (actionType: string, error: string): TrackingEventsAction => ({
    type: TrackingEventsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const trackingEventsGetAllTrackingEvents = (trackingNumber: string): TrackingEventsAction => ({
    type: TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST,
    payload: { trackingNumber },
});